import React, { useEffect, useState } from "react";
import Layout, { PageHeader } from "@/components/Layout";
import { api } from "@/lib/api";
import { BellRinging } from "@phosphor-icons/react";

const CHANNEL_LABEL = {
  email: "Email", sms: "SMS", slack: "Slack", discord: "Discord",
  teams: "Teams", telegram: "Telegram", webhook: "Webhook", push: "Push",
};

export default function Alerts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/alerts"); setItems(data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <Layout>
      <PageHeader title="Alert history" subtitle="Outbound notification log across all channels" />
      <div className="p-6">
        {loading ? <div className="text-sm text-slate-500">loading…</div>
         : items.length === 0 ? (
          <div className="sw-card border-dashed p-16 text-center">
            <BellRinging size={36} weight="duotone" className="text-brand-cyan mx-auto mb-3" />
            <h3 className="font-display text-lg font-bold tracking-tight mb-1">No alerts sent yet</h3>
            <p className="text-sm text-slate-400">Alerts will appear here whenever a failure, warning, or downtime is dispatched.</p>
          </div>
        ) : (
          <div className="sw-card overflow-hidden">
            <table className="w-full text-sm" data-testid="alerts-table">
              <thead className="bg-background-deep/60">
                <tr className="text-[10px] uppercase tracking-[0.15em] text-slate-400">
                  <th className="text-left py-3 px-4">When</th>
                  <th className="text-left py-3 px-4">Channel</th>
                  <th className="text-left py-3 px-4">Subject</th>
                  <th className="text-left py-3 px-4">Recipients</th>
                  <th className="text-left py-3 px-4">Result</th>
                </tr>
              </thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id} className="border-t border-border hover:bg-white/5">
                    <td className="py-3 px-4 text-xs text-slate-400 whitespace-nowrap">
                      {new Date(a.created_at).toLocaleString()}
                    </td>
                    <td className="py-3 px-4 text-xs uppercase tracking-wider text-brand-cyan">
                      {CHANNEL_LABEL[a.channel] || a.channel}
                    </td>
                    <td className="py-3 px-4 text-slate-100 truncate max-w-md">{a.subject}</td>
                    <td className="py-3 px-4 text-xs text-slate-400 truncate max-w-xs">{(a.recipients || []).join(", ")}</td>
                    <td className="py-3 px-4 text-xs">
                      {a.status === "sent" ? (
                        <span className="text-emerald-400">sent</span>
                      ) : (
                        <span className="text-red-400" title={a.error || a.status}>{a.status}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
